<template>
  <div>
    <!-- 大图 -->
    <div class="lunbo-box content">
      <el-carousel class="lunbo-box-item" :interval="5000">
        <el-carousel-item v-for="(item, index) in fileList" :key="index">
          <img :src="item.hiPath">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!--  -->
    <div class="fours content">
      <ul>
        <li class="wow bounceInLeft animated " style="visibility: visible;"><i class="icon"></i><span>技术沟通</span>
        </li>
        <li class="wow bounceInLeft animated " data-wow-duration="1.2s"
          style="visibility: visible; animation-duration: 1.2s;"><i class="icon1"></i><span>开发设计</span></li>
        <li class="wow bounceInLeft animated " data-wow-duration="1s"
          style="visibility: visible; animation-duration: 1s;"><i class="icon2"></i><span>生产制造</span></li>
        <li class="wow bounceInLeft animated " data-wow-duration=".8s"
          style="visibility: visible; animation-duration: 0.8s;"><i class="icon3"></i><span>系统编程</span></li>
        <li class="wow bounceInLeft animated " data-wow-duration=".6s"
          style="visibility: visible; animation-duration: 0.6s;"><i class="icon4"></i><span>安装调试</span></li>
        <li class="wow bounceInLeft animated " data-wow-duration=".4s"
          style="visibility: visible; animation-duration: 0.4s;"><i class="icon5"></i><span>技术培训</span></li>
      </ul>
      <div class="clear"></div>
    </div>

    <div class="centers content">
      <div class="middleLunbo wow fadeInUp2 animate__animated">
        <router-link :to="{ path: '/HzUs', query: { name: '关于恒智' } }" title="关于恒智"><img src="../../images/hrzsgxc.jpg"
            alt="智能控制系统集成、工业自动化产品和信息系统集成服务" title="智能控制系统集成、工业自动化产品和信息系统集成服务" /></router-link>
      </div>
      <div class="rightList fadeInUp2 animate__animated">
        <h2>
          <router-link :to="{ path: '/HzUs', query: { name: '关于恒智' } }" title="关于恒智">
            <span>关于恒智</span><strong>智能控制系统集成、工业自动化产品和信息系统集成服务</strong>
          </router-link>
        </h2>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;开发基于物联网大数据架构的综合信息能源管理平台，为企业和市政提供数字化生产、信息能源管理、安全生产监控和整套智慧城市供水、供暖、环保等解决方案。</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;有丰富的专业技术基础，为工业自动化系统设备商提供全套设计方案、系统集成、机电安装及调试，能为广大客户提供全面技术支持与服务。</p>
      </div>
    </div>

    <!-- 系统控制柜 -->
    <div class="product">
      <div class="content clearfix">
        <h2 class="main_title wow fadeInDown2 animate__animated">
          <a title="系统控制柜"><strong>系统控制柜</strong><span>system control cabinet</span></a>
        </h2>
        <div class="pro_nav wow fadeInLeft2 animate__animated">
          <h3 class="pro_t">
            <strong>系统控制柜分类</strong><br><span>SYSTEMCLASS</span>
          </h3>
          <div :class="index == number ? 'btn1' : ''" v-for="(item, index) in kzgtypeList" :key="index"
            @mouseenter="onEnterTd(index)">
            <h3>
              <router-link class="pro_bor" :to="{ path: '/HzControl', query: { id: item.cmTreeId, name: item.cmName } }">
                <strong>{{ item.cmName }}</strong>
              </router-link>
            </h3>
          </div>
          <div class="pro_more"><router-link :to="{ path: '/HzControl', query: { name: '系统控制柜' } }">查看更多</router-link>
          </div>
        </div>
        <div class="pro_con">
          <div v-for="(item, index) in kzgtypeList" :key="index" v-show="number == index">
            <router-link :to="{ path: '/HzControl', query: { id: item.cmTreeId, name: item.cmName } }">
              <img :alt="item.cmName" :src="item.cmCoverPath" :title="item.cmName">
              <h4>{{ item.cmName }}</h4>
              <span>{{ item.cmBrief }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品中心 -->
    <div class="pro_center">
      <div class="content clearfix">
        <h2 class="main_title wow fadeInDown2 animate__animated">
          <a title="产品中心"><strong>产品中心</strong><span>product display</span></a>
        </h2>
        <div class="pro_bar wow fadeInUp1 animate__animated">
          <div :class="item.id == proNum ? 'hov' : ''" v-for="(item, index) in cptypeList" :key="index"
            @mouseenter="onEnterCp(item.id)">
            <router-link :to="{ path: '/HzProduct', query: { cptype: '品牌', id: item.id, name: item.name } }">
              <h3>
                <strong>{{ item.name }}</strong>
              </h3>
            </router-link>
          </div>
          <div class="more"><router-link :to="{ path: '/HzProduct', query: { name: '产品中心' } }">查看更多 +</router-link></div>
        </div>
        <div class="pro_brand">
          <div v-for="(item, index) in cpBrandList" :key="index" v-show="proNum == item.cmType">
            <router-link :to="{ path: '/HzProduct', query: { id: item.cmTreeId, name: item.cmName } }">
              <div class="bar_pic">
                <img :alt="item.cmName" :src="item.cmCoverPath" :title="item.cmName">
              </div>
              <div class="bra_t">{{ item.cmName }}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术 -->
    <div class="tech">
      <h2 class="main_title wow fadeInDown2 animate__animated">
        <a title="恒智技术服务"><strong>恒智技术服务</strong><span>technical service</span></a>
      </h2>
      <div class="tech_con content wow fadeInUp2 animate__animated">
        <div class="tech_conter" v-for="(item, index) in techList" :key="index">
          <h3>{{ item.name }}</h3>
          <div class="tech_cint">
            <div class="dot"><i></i></div>
            <div class="num">{{ item.num }}</div>
            <p>{{ item.chara }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 案例 -->
    <div class="case_bg clearfix">
      <h2 class="main_title wow fadeInDown2 animate__animated">
        <a title="行业案例"><strong>行业案例</strong><span>industry cases</span></a>
      </h2>
      <div class="case_t content wow fadeInLeft2 animate__animated">
        <div :class="item.cdCode == caseNum ? 'cur' : ''" v-for="(item, index) in caseTList" :key="index"
          @mouseenter="onEnterAl(item.cdCode)">
          <router-link :to="{ path: '/HzHyal', query: { id: item.cdCode, name: item.codeDesc } }">
            <h3>
              <strong>{{ item.codeDesc }}</strong>
            </h3>
          </router-link>
        </div>
      </div>
      <div class="content wow fadeInLeft2 animate__animated">
        <div class="case_qie">
          <div v-for="(item, index) in aiInfoList" :key="index" v-show="caseNum == item.aiTypeId">
            <router-link :to="{ path: '/HzDetails', query: { id: item.aiId, name: item.aiTName, title: '行业案例' } }">
              <img :src="item.aiCoverPath" :alt="item.aiTitle" />
              <!-- <h4>{{ item.title }}</h4> -->
            </router-link>
            <div class="case_r">
              <span>
                <router-link
                  :to="{ path: '/HzDetails', query: { id: item.aiId, name: item.aiTName, title: '行业案例' } }">查看详情+</router-link>
              </span>
              <h5>
                <router-link :to="{ path: '/HzDetails', query: { id: item.aiId, name: item.aiTName, title: '行业案例' } }">{{
                  item.aiTitle }}</router-link>
              </h5>
              <p class="case_desc">{{ item.aiContent }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 优势 -->
    <div class="ys">
      <h2 class="main_title wow fadeInDown2 animate__animated">
        <strong>恒智自控 3 大优势</strong><span>为各行各业实现信息产业自动化服务</span>
      </h2>
      <div class="ys_con  ys1 wow fadeInUp2 animate__animated">
        <dl>
          <dt><img src="../../images/ryzs_20230607172401.jpg" alt="技术创新" title="技术创新" /></dt>
          <dd>
            <h3>
              <strong>技术创新</strong><span>10年研发技术积累 全方位的项目经验</span>
            </h3>
            <p>综合信息能源管理平台，为企业和市政提供<b>数字化生产、信息能源管理、安全生产监控和整套智慧城市供水、供暖、环保</b>等解决方案</p>
            <p>在工业物联网领域取得了显著的成绩，拥有<b>物联网产品专利和12项信息化网络软件著作权，荣获“高新技术企业”称号</b></p>
            <a href="/ryzz" class="info">资质齐全 荣誉加身</a>
          </dd>
        </dl>
        <div class="pic"><img src="../../images/1.png" alt="技术创新" title="技术创新" /></div>
      </div>
      <div class="ys_con ys2 wow fadeInUp2 animate__animated">
        <dl>
          <dt>
            <img src="../../images/ys3.jpg" alt="保质保价" title="保质保价" />
          </dt>
          <dd>
            <h3>
              <strong>保质保价</strong><span>品牌元件厂家长期合作 高品质配置</span>
            </h3>
            <p>
              核心元器件采用ABB、西门子、施耐德、正泰等多种国内外优质品牌元器件，正品高品质配置
            </p>
            <p>
              集中采购，性能稳定、功能齐全，成本更低，根据客户需求，设计规划，合理集成，实现完美组合，达到性价比经得起市场比较
            </p>
            <a href="/Helps/gywm" target="_blank" class="info">8000㎡生产基地 1000㎡仓库</a>
          </dd>
        </dl>
        <div class="pic"><img src="../../images/2.png" alt="保质保价" title="保质保价" /></div>
      </div>
      <div class="ys_con ys3 wow fadeInUp2 animate__animated">
        <dl>
          <dt><img src="../../images/ys4.jpg" alt="放心售后" title="放心售后" /></dt>
          <dd>
            <h3>
              <strong>放心售后</strong><span>热情 优势 迅捷 周到</span>
            </h3>
            <p>拥有完善的技术和人员配置，为客户提供<b>充沛的货源以及优质、便捷、高效的服务</b></p>
            <p>一如既往的为工业生产制造、数字化工厂、智慧城市和市政民生等领域服务，提供优质产品和解决方案</p>
            <p><b>为各行各业实现信息产业自动化服务</b></p>
            <a href="http://wpa.qq.com/msgrd?v=3&site=恒智电气&menu=yes&uin=2128939336" target="_blank"
              class="shangqiao info">一年以上质保 终身售后服务</a>
          </dd>
        </dl>
        <div class="pic"><img src="../../images/3.png" alt="放心售后" title="放心售后" /></div>
      </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'
import router from '../../router'

export default {
  name: 'Home',
  components: {
    router
  },
  data() {
    return {
      animate: false,
      list: [
      ],
      stop: null,
      autoplaySpeed: 1000,
      image: '',
      scbz: [],
      banner: '',

      fileList: [],//轮播图
      number: 0,
      cptypeList: [],//产品中心
      cpBrandList: [],
      proNum: null,
      kzgtypeList: [],//系统控制柜
      techList: [
        {
          name: '电气自动化控制定制',
          num: '01',
          chara: '项目设计规划及技术交流、技术方案编制、合理规划设备配置，从而更好的保障系统运行的可靠性、稳定性以及使用寿命长久性。另一方面也能根据客户实际需求情况进行配置优化，降低成本。'
        },
        {
          name: '集控方案设计',
          num: '02',
          chara: '编写PLC控制程序、搭建SCADA上位控制系统等对设备进行系统运行监视及自动化控制，确保及时、全面、有效的掌握设备的实际运行的状况。'
        },
        {
          name: '现场安装调试',
          num: '03',
          chara: '配备专业技术人员及机电安装队伍，机电工程设备安装、施工安装技术指导、设备技术培训、工程试验验收等，用心完成每一个环节。'
        },
        {
          name: '工控物联网',
          num: '04',
          chara: '通过手机APP与监控云平台，可实现设备远程监控和远程故障诊断，不仅仅可以打破时间、空间、地域等限制，进而减少排除故障时间，降低运行维护成本。'
        }
      ],
      caseNum: null,
      caseTList: [],//行业案例分类
      aiInfo: [],
      aiInfoList: [],//案例内容
      currentOffset: 0,
      paginationFactor: 305, //移动距离：每个内层展示div宽度(包括margin)
    }
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.arr[this.number],
      }
    },
  },
  created() {
    // 页面显示
    this.image = http.imageURL
    this.queryLbt();
    // this.queryCpMenu();
    this.queryCpTree();
    this.queryAlType();
  },
  mounted() {
    // 可见数据高度
    // this.$refs.marquee_box.style.height = this.showNum * 30 + 'px'
    this.$nextTick(() => {
      if (!(/msie [6|7|8|9]/i.test(navigator.userAgent))) {
        new this.$wow.WOW().init()
      }
    })
  },
  watch: {
    $route() {
      if (this.$router.history.current.query.name !== this.name) {
        this.$router.go();
      }
    }
  },
  methods: {
    //鼠标进入的事件。
    onEnterTd(index) {
      this.number = index;
    },
    onEnterAl(cdCode) {
      this.caseNum = cdCode;
      this.changeAl();
    },
    onEnterCp(id) {
      this.proNum = id;
      this.queryCpMenu();
    },
    //点击左右移动按钮的方法
    moveCarousel(direction) {
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
        this.butt_ok = 1;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
        this.butt_ok = 0;
      }
    },
    queryLbt() {
      http.get('/hzhomeimg/lunbo').then((res) => {
        this.fileList = res.data.data.result;
        this.fileList.forEach(item => {
          item.hiPath = this.image + item.hiPath;
        })
      })
    },
    //系统控制柜、产品中心查询
    queryCpTree() {
      http.get('/hzCpTree/cpTree', { params: { menuT: 'P' } }).then((res) => {
        this.cptypeList = res.data.data.result[0].children;
        this.proNum = this.cptypeList[0].id;
        this.queryCpMenu();
      })
    },
    queryCpMenu() {
      http.get('/hzCpMenu/cpMenu', { params: { cmType: this.proNum } }).then((res) => {
        this.kzgtypeList = res.data.data.result;
        console.log(this.kzgtypeList);
        this.kzgtypeList.forEach(item => {
          item.cmCoverPath = this.image + item.cmCoverPath;
        })
        this.cpBrandList = res.data.data.cpBrand;
        this.cpBrandList.forEach(item => {
          item.cmCoverPath = this.image + item.cmCoverPath;
        })
      })
    },
    queryAlType() {
      http.get('/hzAlInfo/aiType', { params: { aiIsHome: '0' } }).then((res) => {
        this.aiInfo = res.data.data.result;
        this.caseTList = res.data.data.aiType;
        if (this.aiInfo.length > 0) {
          this.aiInfo.forEach(item => {
            item.aiContent.replace(/<[^>]*>/g, '');  
            item.aiCoverPath = this.image + item.aiCoverPath;
          })
          // console.log(this.aiInfo);
          this.caseNum = this.aiInfo[0].aiTypeId;
          this.changeAl();
        }
      })
    },
    changeAl() {
      this.aiInfoList = [];
      this.aiInfo.forEach(e => {
        if (e.aiTypeId === this.caseNum) {
          this.aiInfoList.push(e);
        }
      })
    }
  }
}
</script>


<style>
@import "../../config/common.css"


/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 15px; */
</style>



// WEBPACK FOOTER //
// src/views/dashboard/Home.vue